import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/core/material.module';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DeviceStatus, deviceStatusLabel } from 'src/app/features/tests/features/constants';
import { DeviceService } from '../../services/devices.service';
import { trackFeatureUse } from 'src/app/core/analytics';

@Component({

  selector: 'app-devices-status-dialog',
  templateUrl: 'devices-status-dialog.component.html',
  styleUrls: ['./devices-status-dialog.component.scss'],
  imports: [MaterialModule,CommonModule]
})
export class DeviceStatusDialogComponent implements OnInit {
  loader = false;
  constructor(
    private devicesService: DeviceService,
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<DeviceStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {status: DeviceStatus, type: 'all' | 'available'}) {}

  ngOnInit() {
  }

  /** The confirmation copy names the status, so use the on-screen wording. */
  get statusLabel(): string {
    return deviceStatusLabel(this.data.status);
  }

  changeStatus() {
    trackFeatureUse('devices', `status_${this.data.status}`);
    this.loader = true;
    this.devicesService.updateStatus({status: this.data.status}, {type: this.data.type}).subscribe({
      next: (res) => {
        this.loader = false;
        this.notificationService.success('Devices Status Changed Successfully');
        this.dialogRef.close(true)
      },
      error: (error) => {
        this.loader = false;
        console.error('Error loading devices:', error);
      },
    });
  }

}
